(function() {
  "use strict";

    angular.module("eSign")
    .service('fileUpload', ['$http', '$window', function ($http, $window) {
      this.uploadFileToUrl = function(files, requiredUploads, uploadURL) {
          // TODO: FormData object is not supported by IE9 and earlier.
          var fd = new FormData();
          
          for (var i = 0; i < files.length; i++) {
              fd.append("uploadReferences", requiredUploads[i].uploadReference);
              fd.append("files", files[i][0]);
          }

          return $http.post(uploadURL, fd, {
              transformRequest: angular.identity,
              headers: {'Content-Type': undefined}
          });
      }
    }]);
}());
